export default __webpack_public_path__ + "static/holidays-hero-bg-97bceaa628488cf6fae17e50b5cd2fab.jpg";